var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcActiveAdmire(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "95.394%",
    y1: "100%",
    x2: "4.606%",
    y2: "0%",
    id: "wuacvwubta"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95FFF6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C88FF",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0c-.202 0-.404.133-.404.399v1.199c0 .543.808.543.808 0v-1.2C9.904.134 9.702 0 9.5 0zm4.205 1.463-.838.828c-.403.397.165.962.568.564l.842-.83c.394-.388-.197-.933-.572-.562zm-8.99.664.854.848c.389.386.962-.18.572-.565l-.855-.845c-.377-.372-.96.177-.572.562zM9.126 4.26 6.024 8.701 3.313 4.259h5.814zm6.563 0-2.713 4.443L9.9 4.259h5.79zm-12.798.01 2.756 4.423H0L2.892 4.27zm6.621-.025 3.058 4.448H6.455l3.058-4.448zm6.533.025L19 8.692h-5.596l2.642-4.423zm-3.438 4.794L9.501 19.94 6.393 9.063h6.215zm-6.637 0L9.114 19.76.076 9.063H5.97zm12.956 0L9.94 19.76l3.09-10.698h5.896z",
    transform: "translate(0 .268)",
    fill: "url(#wuacvwubta)",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActiveAdmire);
export default __webpack_public_path__ + "static/media/ic_active_admire.aa4feb8113ef242046f8de56aef72b74.svg";
export { ForwardRef as ReactComponent };